module.exports = __webpack_public_path__ + "img/hdd-fill.afa23657.svg";